import { createApp } from "vue";
import VueAxios from "vue-axios";
import VueCookies from "vue3-cookies";
import Paginate from "vue3-paginate-z";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faUserSecret,
  faPiggyBank,
  faVault,
  faBell,
  faCommentDots,
  faCaretDown,
  faUserTie,
  faUnlockAlt,
  faBarsStaggered,
  faCaretUp,
  faRightFromBracket,
  faWindowRestore,
  faCircleUser,
  faHandHoldingDollar,
  faMoneyBill,
  faMoneyBill1Wave,
  faReply,
  faHandshake,
  faGift,
  faPlay,
  faTrophy,
  faCrown,
  faTableList,
  faMoneyBillTransfer,
  faUserGear,
  faCircleInfo,
  faClover,
  faFireFlameCurved,
  faBomb,
  faTablet,
  faPuzzlePiece,
  faClockRotateLeft,
  faMagnifyingGlassPlus,
  faComments,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import VueMobileDetection from "vue-mobile-detection";
import axios from "axios";
import { createPinia } from 'pinia';

import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import { initGlobal } from './config/global';
import { initApi } from './config/api';
import { initSweetAlert } from './config/sweetalert';

import "sweetalert2/dist/sweetalert2.min.css";
import "vue3-paginate-z/dist/styles.css";

library.add(
  faUserSecret,
  faPiggyBank,
  faVault,
  faBell,
  faCommentDots,
  faCaretDown,
  faUserTie,
  faUnlockAlt,
  faBarsStaggered,
  faCaretUp,
  faRightFromBracket,
  faWindowRestore,
  faCircleUser,
  faHandHoldingDollar,
  faMoneyBill,
  faMoneyBill1Wave,
  faReply,
  faHandshake,
  faGift,
  faPlay,
  faTrophy,
  faCrown,
  faTableList,
  faMoneyBillTransfer,
  faUserGear,
  faCircleInfo,
  faClover,
  faFireFlameCurved,
  faBomb,
  faTablet,
  faPuzzlePiece,
  faClockRotateLeft,
  faMagnifyingGlassPlus,
  faComments,
  faEye
);

const app = createApp(App);
const pinia = createPinia();

app.use(VueMobileDetection);
app.use(VueAxios, axios);
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(Paginate);
app.use(VueCookies);
app.use(i18n);
app.use(router);
app.use(store);
app.use(pinia);

initGlobal(app);
initApi(app, axios);
initSweetAlert(app);

app.mount("#app");
